(function(config) {
    'use strict';

    angular.module('montage.services', [
            'ngResource'
        ])
        .factory('montageDataSrvc', montageDataSrvc)
        .factory('montageSrvc', montageSrvc)
        .factory('montageProductDataSrvc', montageProductDataSrvc);

    montageDataSrvc.$inject = ['$resource', 'transformResponseSrvc'];

    function montageDataSrvc($resource, transformResponseSrvc) {
        return $resource(config.api + '/api/v1/montages/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/montages/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
            },
            update: {
                method: 'PATCH',
            },
            stateUpdate: {
                method: 'PATCH',
                url: config.api + '/api/v1/montages/:pk/admin_state_update/',
            },
            startMontage: {
                method: 'PATCH',
                url: config.api + '/api/v1/montages/:pk/start_process/',
            },
            duplicate: {
                method: 'POST',
                url: config.api + '/api/v1/montages/:pk/admin_duplicate/',
                params: {
                    pk: '@pk'
                }
            },
            delete: {
                method: 'DELETE'
            },
            retrieve: {
                method: 'GET',
                url: config.api + '/api/v1/montages/:pk/',
                params: {
                    pk: '@pk'
                }
            },
            montageCard: {
                method: 'GET',
                url: config.api + '/api/v1/montages/:pk/admin_montage_card/',
                params: {
                    pk: '@pk'
                },
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.pdfArrayBufferTransform
            },
            getMontageProductionLogs: {
                method: 'GET',
                url: config.api + '/api/v1/montages/:pk/production_logs/',
                params: {
                    pk: '@pk'
                }
            },
        });
    }

    montageSrvc.$inject = ['$q', '$state', 'montageDataSrvc', 'modalSrvc', 'momentSrvc', 'montageMessagesConst', 'notificationSrvc', 'downloadLinkSrvc', 'errorNotificationSrvc'];

    function montageSrvc($q, $state, montageDataSrvc, modalSrvc, momentSrvc, montageMessagesConst, notificationSrvc, downloadLinkSrvc, errorNotificationSrvc) {

        return {
            getMontageCard: getMontageCard,

            remove: remove,
            duplicate: duplicate,
            getRealizationDate: getRealizationDate,
            getMontageProductsCount: getMontageProductsCount,
            getUniqueOrdersCount: getUniqueOrdersCount,
            getMontageProductsPrice: getMontageProductsPrice,
            getMontagePrice: getMontagePrice,

            isClosedDisabled: isClosedDisabled,
            isMountedDisabled: isMountedDisabled,
            isRadiatedDisabled: isRadiatedDisabled,
            isPrintedDisabled: isPrintedDisabled,

            setClosedMontage: setClosedMontage,
            setMountedMontage: setMountedMontage,
            setRadiatedMontage: setRadiatedMontage,
            setPrintedMontage: setPrintedMontage,
        };

        function getMontageCard(montage) {
            return montageDataSrvc.montageCard({
                pk: montage.pk
            }).$promise.then(
                function(response) {
                    downloadLinkSrvc.saveFile(response);
                    return response;
                }
            );
        }

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    montageDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }

        function duplicate(montage, successCallback, errorCallback) {
            modalSrvc.confirmAction(
                'zduplikować montaż o nr: ' + montage.pk + ' (bez przypisanych zleceń)',
                function() {
                    if (errorCallback) errorCallback();
                    montageDataSrvc.duplicate({pk: montage.pk}).$promise.then(
                        function(response) {
                            notificationSrvc.notification('success', montageMessagesConst.duplicated);
                            $state.go('layout.montage.update', {pk: response.pk});
                        },
                        function(response) {
                            errorNotificationSrvc.displayErrors(response.data);
                            if (errorCallback) errorCallback();
                        }
                    );
                }
            );
        }

        function getRealizationDate(montageData, products) {
            var montageDeadline,
                minProductDate,
                minDate;

            if (montageData.forced_deadline_date) {
                montageDeadline = momentSrvc.strToDate(montageData.forced_deadline_date);
            } else {
                montageDeadline = undefined;
            }

            if (products.length) {
                minProductDate = products.reduce(function(a, b) {
                    var aDate = momentSrvc.strToDate(a.order_realization_date);
                    var bDate = momentSrvc.strToDate(b.order_realization_date);
                    return aDate < bDate ? aDate : bDate;
                });
            } else {
                minProductDate = undefined;
            }

            if (montageDeadline && minProductDate) {
                minDate = montageDeadline < minProductDate ? montageDeadline : minProductDate;
            } else if (montageDeadline) {
                minDate = montageDeadline;
            } else if (minProductDate) {
                minDate = minProductDate;
            } else {
                return undefined;
            }

            return momentSrvc.dateToStr(minDate);
        }

        function getMontageProductsCount(products) {
            return products.length;
        }

        function getUniqueOrdersCount(products) {
            var order_pks = [];

            products.forEach(function(item) {
                if (order_pks.indexOf(item.order_pk) === -1) {
                    order_pks.push(item.order_pk);
                }
            });

            return order_pks.length;
        }

        function getMontageProductsPrice(products, productsProp) {
            return products.reduce(function(a, b) {
                return a + b[productsProp];
            }, 0.0);
        }

        function getMontagePrice(montageData, paperOption, sheetFormat, plate) {
            var platePrice = 0,
                montageBrutto = 0,
                paperPrice = 0,
                plateQuantity = 0,
                montageExtraNet = 0,
                plateSizeX = plate ? plate.size_x : 0,
                plateSizeY = plate ? plate.size_y : 0,
                plateUnitPrice = plate ? plate.price : 0,
                sheetSizeX = sheetFormat ? sheetFormat.size_x : 0,
                sheetSizeY = sheetFormat ? sheetFormat.size_y : 0,
                paperOptionWeight = paperOption ? paperOption.weight : 0,
                paperOptionPrice = paperOption ? paperOption.paper_price : 0;

            platePrice = getNumber(plateSizeX) / 1000 * getNumber(plateSizeY) / 1000 * getNumber(plateUnitPrice);

            montageBrutto = getNumber(montageData.quantity_net) + getNumber(montageData.quantity_surplus);

            paperPrice = getNumber(sheetSizeX) / 1000 * getNumber(sheetSizeY) / 1000 * getNumber(paperOptionWeight) / 1000 * getNumber(paperOptionPrice);

            plateQuantity = getNumber(montageData.plate_quantity);

            montageExtraNet = getNumber(montageData.extra_net);

            return montageBrutto * paperPrice + plateQuantity * platePrice + montageExtraNet;
        }

        function isClosedDisabled(montage) {
            return false;
        }

        function isMountedDisabled(montage) {
            return montage.closed === false ||
                montage.radiated === true ||
                montage.printed === true;
        }

        function isRadiatedDisabled(montage) {
            return montage.closed === false ||
                montage.mounted === false ||
                montage.printed === true;
        }

        function isPrintedDisabled(montage) {
            return montage.closed === false ||
                montage.mounted === false ||
                montage.radiated === false;
        }

        function setClosedMontage(montage) {
            montageDataSrvc.stateUpdate({
                pk: montage.pk
            }, {
                closed: !montage.closed
            }).$promise.then(
                function(response) {
                    montage.closed = !montage.closed;

                    if (montage.closed) {
                        notificationSrvc.notification("success", montageMessagesConst.closed);
                    } else {
                        notificationSrvc.notification("success", montageMessagesConst.unclosed);
                    }
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.closed.join('; '));
                }
            );
        }

        function setMountedMontage(montage) {
            montageDataSrvc.stateUpdate({
                pk: montage.pk
            }, {
                mounted: !montage.mounted
            }).$promise.then(
                function(response) {
                    montage.mounted = !montage.mounted;

                    if (montage.mounted) {
                        notificationSrvc.notification("success", montageMessagesConst.mounted);
                    } else {
                        notificationSrvc.notification("success", montageMessagesConst.unmounted);
                    }
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.mounted.join('; '));
                }
            );
        }

        function setRadiatedMontage(montage) {
            montageDataSrvc.stateUpdate({
                pk: montage.pk
            }, {
                radiated: !montage.radiated
            }).$promise.then(
                function(response) {
                    montage.radiated = !montage.radiated;

                    if (montage.radiated) {
                        notificationSrvc.notification("success", montageMessagesConst.radiated);
                    } else {
                        notificationSrvc.notification("success", montageMessagesConst.unradiated);
                    }
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.radiated.join('; '));
                }
            );
        }

        function setPrintedMontage(montage) {
            montageDataSrvc.stateUpdate({
                pk: montage.pk
            }, {
                printed: !montage.printed
            }).$promise.then(
                function(response) {
                    montage.printed = !montage.printed;

                    if (montage.printed) {
                        notificationSrvc.notification("success", montageMessagesConst.printed);
                    } else {
                        notificationSrvc.notification("success", montageMessagesConst.unprinted);
                    }
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.printed.join('; '));
                }
            );
        }

        function isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function getNumber(n) {
            return isNumeric(n) ? n : 0;
        }
    }

    montageProductDataSrvc.$inject = ['$resource'];

    function montageProductDataSrvc($resource) {
        return $resource(config.api + '/api/v1/montage-products/:pk/', { pk: '@pk' }, {
            update: {
                method: 'PATCH',
            },
            leftTable: {
                method: 'GET',
                url: config.api + '/api/v1/montage-products/admin_list_left_table/',
                params: {
                    page: '@page'
                }
            },
            rightTable: {
                method: 'GET',
                url: config.api + '/api/v1/montage-products/admin_list_right_table/',
                params: {
                    page: '@page'
                }
            }
        });
    }
})(window.config);
